import { observer } from 'mobx-react';
import { FC } from 'react';
import ItemCrossSellingItem from '../../components/ItemCrossSellingItem/ItemCrossSellingItem';
import itemsStore from '../../store/itemsStore';
import { emptyArray } from 'src/utils/helpers';

const ItemCrossSellingItems: FC = observer((): JSX.Element | null => {
  if (!itemsStore.item) return null;

  if (itemsStore.item.upsales_items.length && !itemsStore.crossSellingItems?.length) {
    return (
      <>
        {emptyArray().map((_, index) => (
          <ItemCrossSellingItem key={'key-' + String(index)} />
        ))}
      </>
    );
  }

  if (itemsStore.crossSellingItems?.length) {
    return (
      <>
        {itemsStore.crossSellingItems.map((item) => (
          <ItemCrossSellingItem key={item.id} item={item} />
        ))}
      </>
    );
  }

  return null;
});

export default ItemCrossSellingItems;
